import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Toast } from 'antd-mobile';
import config from '../../config/config';
import { replaceNumber, validateImgcode } from '../../utils/validate';

import './ImageAuth.scss';
import closeIcon from '../../assets/images/home/icon_close@2x.png'; 

class ImageAuth extends Component {
  state = {
    imageCode: '',
    imageNum: '',
  }

  componentDidMount() {
    this.props.onRef(this);
    this.getImageNum();
  }

  clearImg = () => {
    this.setState({
      imageCode: ''
    }) 
    this.getImageNum();
  }

  getImageNum = () => {
    let num = '';
    for (let i = 0; i < 32; i += 1) {
      num += Math.floor(Math.random() * 10);
    }
    this.setState({
      imageNum: num
    })
  }

  handelInput = (key, maxLength, event) => {
    const str = replaceNumber(event.target.value, maxLength);
    this.setState({
      [key]: str,
    })
  }

  confirm = () => {
    if (!validateImgcode(this.state.imageCode)) {
      Toast.info('请输入正确的验证码！', 2);
      return;
    }
    this.props.imgSuccess({
      requestId: this.state.imageNum,
      validationCode: this.state.imageCode
    });
  }

  render () {
    return (
      <div className='imageAuth mask'>
        <div className='content'>
          <div className='title'>图形验证</div>
          <div className='code'>
            <input type="text"
              placeholder="请入图形验证码"
              name="imageCode"
              maxLength="4"
              value={this.state.imageCode}
              onFocus={this.handelInput.bind(this, 'imageCode', 4)}
              onChange={this.handelInput.bind(this, 'imageCode', 4)} />
              <img onClick={this.getImageNum} src={`${config.backendBaseUrl}/spread/web/common/validationCode/${this.state.imageNum}`} alt="" />
          </div>
          <div className='confirm' onClick={this.confirm}>确定</div>
        </div>
        <img className='close' src={closeIcon} onClick={this.props.closeImgAuth} alt="" />
      </div>
    )
  }
}

ImageAuth.propTypes = {
  imgSuccess: PropTypes.func,
  closeImgAuth: PropTypes.func
}

export default ImageAuth;